import { config } from 'config/config';
import { useEffect, useState } from 'react';
import { PlatformEnum } from 'src/shared/enums';
import { ComboData } from 'src/shared/models';
import {
  getRegions,
  getProvinces,
  getDistricts,
  getDepartments,
  getSuburbs,
  getCLComunas,
} from 'utils';

export const useGetAddressConfig = () => {
  const { PLATFORM } = config.APP;
  const [regionList, setRegionList] = useState<ComboData[]>([]);
  const [departmentList, setDepartmentList] = useState<ComboData[]>([]);
  const [provinceList, setProvinceList] = useState<ComboData[]>([]);
  const [districtList, setDistrictList] = useState<ComboData[]>([]);

  useEffect(() => {
    async function fetchRegions() {
      const regions = await getRegions();
      setRegionList(regions);
    }
    fetchRegions();

    // Some extra calls per platform
    switch (PLATFORM) {
      case PlatformEnum.CON_DEUTSCHLAND: {
        async function fetchProvinces() {
          const provinces = await getProvinces();
          setProvinceList(provinces);
        }
        fetchProvinces();

        async function fetchDistricts() {
          const districts = await getDistricts();
          setDistrictList(districts);
        }
        fetchDistricts();
        return;
      }
      case PlatformEnum.CON_PERU: {
        async function fetchDepartments() {
          const departments = await getDepartments();
          setDepartmentList(departments);
        }
        fetchDepartments();

        async function fetchProvinces() {
          const provinces = await getProvinces();
          setProvinceList(provinces);
        }
        fetchProvinces();

        async function fetchDistricts() {
          const districts = await getDistricts();
          setDistrictList(districts);
        }
        fetchDistricts();
        return;
      }
      case PlatformEnum.CON_MEXICO: {
        async function fetchSuburbs() {
          const suburbs = await getSuburbs();
          setDistrictList(suburbs);
        }
        fetchSuburbs();
        return;
      }
      case PlatformEnum.CON_PORTUGAL: {
        async function fetchProvinces() {
          const provinces = await getProvinces();
          setProvinceList(provinces);
        }
        fetchProvinces();
        return;
      }
      case PlatformEnum.CON_CHILE: {
        async function fetchComunas() {
          const comunas = await getCLComunas();
          setDistrictList(comunas);
        }
        fetchComunas();
        return;
      }
    }
  }, []);

  return { regionList, departmentList, provinceList, districtList };
};
